(function (global) {
  'use strict';

  var COMPONENT_NAME = 'vl-blog-double-add-module';
  var TAB_SELECTOR = '[data-vl-blog-product-tab]';
  var PANEL_SELECTOR = '[data-vl-blog-product-panel]';
  var VIEWPORT_SELECTOR = '[data-vl-blog-product-viewport]';
  var SHORTCODE_SELECTOR = '[data-vl-blog-double-add-shortcode]';
  var shortcodeInstanceCount = 0;

  function clampIndex(index, length) {
    if (!length) return 0;
    return (Number(index) % length + length) % length;
  }

  function productCardUrl(handle) {
    return '/products/' + encodeURIComponent(String(handle || '')) + '?view=vl-blog-double-add-card';
  }

  function parseBoolean(value, fallback) {
    if (value == null || value === '') return Boolean(fallback);
    var normalized = String(value).trim().toLowerCase();
    if (normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on') return true;
    if (normalized === 'false' || normalized === '0' || normalized === 'no' || normalized === 'off') return false;
    return Boolean(fallback);
  }

  function readDataValue(slot, datasetKey, attributeName) {
    if (slot && typeof slot.getAttribute === 'function') {
      var attributeValue = slot.getAttribute(attributeName);
      if (attributeValue != null) return attributeValue;
    }
    var data = slot && slot.dataset ? slot.dataset : {};
    return data[datasetKey];
  }

  function parseShortcodeConfig(slot) {
    var data = slot && slot.dataset ? slot.dataset : {};
    var firstHandle = String(readDataValue(slot, 'product-1Handle', 'data-product-1-handle') || '').trim();
    if (!firstHandle) return null;

    var products = [{
      handle: firstHandle,
      label: String(readDataValue(slot, 'product-1Label', 'data-product-1-label') || '').trim()
    }];
    var secondHandle = String(readDataValue(slot, 'product-2Handle', 'data-product-2-handle') || '').trim();
    if (secondHandle) {
      products.push({
        handle: secondHandle,
        label: String(readDataValue(slot, 'product-2Label', 'data-product-2-label') || '').trim()
      });
    }

    return {
      products: products.slice(0, 2),
      discountType: String(data.discountType || 'none').trim() || 'none',
      discountValue: Math.max(0, Number(data.discountValue) || 0),
      showIntro: parseBoolean(data.showIntro, false),
      showFeatures: parseBoolean(data.showFeatures, false),
      eyebrow: String(data.eyebrow || '').trim(),
      heading: String(data.heading || '').trim()
    };
  }

  function createElement(documentRef, tagName, className) {
    var element = documentRef.createElement(tagName);
    if (className) element.className = className;
    return element;
  }

  function createLoadingState(documentRef, label) {
    var loading = createElement(documentRef, 'div', 'vl-blog-double-add-module__loading');
    loading.setAttribute('data-vl-blog-product-loading', '');

    var media = createElement(documentRef, 'span', 'vl-blog-double-add-module__loading-media');
    var line = createElement(documentRef, 'span', 'vl-blog-double-add-module__loading-line');
    var shortLine = createElement(
      documentRef,
      'span',
      'vl-blog-double-add-module__loading-line vl-blog-double-add-module__loading-line--short'
    );
    var accessibleLabel = createElement(documentRef, 'span', 'visually-hidden');
    accessibleLabel.textContent = 'Loading ' + label;
    loading.append(media, line, shortLine, accessibleLabel);
    return loading;
  }

  function hydrateShortcode(slot) {
    if (!slot || slot.dataset.vlBlogDoubleAddHydrated === 'true') return null;
    slot.dataset.vlBlogDoubleAddHydrated = 'true';

    var config = parseShortcodeConfig(slot);
    if (!config) {
      slot.dataset.vlBlogDoubleAddError = 'missing-product-1';
      console.warn('[VL Blog double add module] Shortcode requires data-product-1-handle.');
      return null;
    }

    var documentRef = slot.ownerDocument || global.document;
    if (!documentRef || !documentRef.createElement) return null;
    shortcodeInstanceCount += 1;
    var instanceId = 'VlBlogDoubleAddShortcode-' + shortcodeInstanceCount;
    var module = createElement(
      documentRef,
      COMPONENT_NAME,
      'vl-blog-double-add-module article-container vl-blog-double-add-module--embedded'
    );
    module.setAttribute('data-vl-blog-double-add-module', '');
    module.dataset.productCount = String(config.products.length);
    module.dataset.vlBlogShowIntro = String(config.showIntro);
    module.dataset.vlBlogShowFeatures = String(config.showFeatures);
    if (slot.id) module.id = slot.id;
    if (slot.classList) {
      Array.from(slot.classList).forEach(function (className) {
        module.classList.add(className);
      });
    }

    var hasHeading = Boolean(config.eyebrow || config.heading);
    var header = createElement(
      documentRef,
      'div',
      'vl-blog-double-add-module__header' + (hasHeading ? '' : ' vl-blog-double-add-module__header--tabs-only')
    );
    if (hasHeading) {
      var headingWrap = createElement(documentRef, 'div', 'vl-blog-double-add-module__heading');
      if (config.eyebrow) {
        var eyebrow = createElement(documentRef, 'span', 'vl-blog-double-add-module__eyebrow');
        eyebrow.textContent = config.eyebrow;
        headingWrap.appendChild(eyebrow);
      }
      if (config.heading) {
        var heading = createElement(documentRef, 'h2', 'vl-blog-double-add-module__title');
        heading.textContent = config.heading;
        headingWrap.appendChild(heading);
      }
      header.appendChild(headingWrap);
    }

    var tabs = createElement(
      documentRef,
      'div',
      'vl-blog-double-add-module__tabs' + (config.products.length === 1 ? ' vl-blog-double-add-module__tabs--single' : '')
    );
    tabs.setAttribute('role', 'tablist');
    tabs.setAttribute('aria-label', 'Choose a product');
    tabs.setAttribute('data-vl-blog-product-tabs', '');
    var indicator = createElement(documentRef, 'span', 'vl-blog-double-add-module__tab-indicator');
    indicator.setAttribute('aria-hidden', 'true');
    tabs.appendChild(indicator);

    var viewport = createElement(documentRef, 'div', 'vl-blog-double-add-module__viewport');
    viewport.setAttribute('data-vl-blog-product-viewport', '');

    config.products.forEach(function (product, index) {
      var tabId = instanceId + '-Tab-' + index;
      var panelId = instanceId + '-Panel-' + index;
      var fallbackLabel = 'Product ' + (index + 1);
      var tab = createElement(
        documentRef,
        'button',
        'vl-blog-double-add-module__tab' + (index === 0 ? ' is-active' : '')
      );
      tab.id = tabId;
      tab.type = 'button';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
      tab.setAttribute('data-vl-blog-product-tab', '');
      tab.dataset.productIndex = String(index);
      tab.dataset.autoLabel = product.label ? 'false' : 'true';
      var tabLabel = documentRef.createElement('span');
      tabLabel.textContent = product.label || fallbackLabel;
      tab.appendChild(tabLabel);
      tabs.appendChild(tab);

      var panel = createElement(
        documentRef,
        'div',
        'vl-blog-double-add-module__panel' + (index === 0 ? ' is-active' : '')
      );
      panel.id = panelId;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabId);
      panel.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      panel.setAttribute('aria-busy', 'true');
      panel.setAttribute('tabindex', index === 0 ? '0' : '-1');
      panel.setAttribute('data-vl-blog-product-panel', '');
      panel.setAttribute('data-vl-blog-product-slot', '');
      panel.dataset.productIndex = String(index);
      panel.dataset.productHandle = product.handle;
      panel.dataset.vlBlogDiscountType = config.discountType;
      panel.dataset.vlBlogDiscountValue = String(config.discountValue);
      panel.appendChild(createLoadingState(documentRef, product.label || fallbackLabel));
      viewport.appendChild(panel);
    });

    header.appendChild(tabs);
    module.append(header, viewport);
    slot.replaceWith(module);
    return module;
  }

  function initShortcodes(root) {
    var scope = root && root.querySelectorAll ? root : global.document;
    if (!scope || !scope.querySelectorAll) return [];
    var slots = Array.from(scope.querySelectorAll(SHORTCODE_SELECTOR));
    if (scope.matches && scope.matches(SHORTCODE_SELECTOR)) slots.unshift(scope);
    return slots.map(hydrateShortcode).filter(Boolean);
  }

  var HTMLElementBase = global.HTMLElement || class {};

  class VlBlogDoubleAddModule extends HTMLElementBase {
    connectedCallback() {
      if (this.controllerAbort) return;

      this.tabs = Array.from(this.querySelectorAll(TAB_SELECTOR));
      this.panels = Array.from(this.querySelectorAll(PANEL_SELECTOR));
      this.viewport = this.querySelector(VIEWPORT_SELECTOR);
      if (!this.tabs.length || !this.panels.length || !this.viewport) return;

      this.activeIndex = Math.max(0, this.tabs.findIndex(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      }));
      this.controllerAbort = new AbortController();
      this.reducedMotion = global.matchMedia
        ? global.matchMedia('(prefers-reduced-motion: reduce)')
        : { matches: false };

      this.addEventListener('click', this.handleClick.bind(this), {
        signal: this.controllerAbort.signal
      });
      this.addEventListener('keydown', this.handleKeydown.bind(this), {
        signal: this.controllerAbort.signal
      });
      global.addEventListener('resize', this.handleResize.bind(this), {
        signal: this.controllerAbort.signal
      });

      this.setActiveProduct(this.activeIndex, false, false);
      this.loadAllProducts();
      global.requestAnimationFrame(this.updateIndicator.bind(this));
    }

    disconnectedCallback() {
      if (this.controllerAbort) this.controllerAbort.abort();
      this.controllerAbort = null;
      if (this.heightTimer) global.clearTimeout(this.heightTimer);
    }

    handleClick(event) {
      var tab = event.target.closest(TAB_SELECTOR);
      if (!tab || !this.contains(tab)) return;
      this.setActiveProduct(Number(tab.dataset.productIndex), true, false);
    }

    handleKeydown(event) {
      var tab = event.target.closest(TAB_SELECTOR);
      if (!tab || !this.contains(tab)) return;

      var index = Number(tab.dataset.productIndex);
      var nextIndex = index;
      if (event.key === 'ArrowRight') nextIndex = clampIndex(index + 1, this.tabs.length);
      else if (event.key === 'ArrowLeft') nextIndex = clampIndex(index - 1, this.tabs.length);
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = this.tabs.length - 1;
      else return;

      event.preventDefault();
      this.setActiveProduct(nextIndex, true, true);
    }
    handleResize() {
      this.updateIndicator();
      if (this.viewport.style.height) this.syncViewportHeight(false);
    }

    setActiveProduct(index, animate, focusTab) {
      var nextIndex = clampIndex(index, Math.min(this.tabs.length, this.panels.length));
      var startHeight = this.viewport.getBoundingClientRect().height;
      this.activeIndex = nextIndex;

      this.tabs.forEach(function (tab, tabIndex) {
        var active = tabIndex === nextIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      this.panels.forEach(function (panel, panelIndex) {
        var active = panelIndex === nextIndex;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        panel.setAttribute('tabindex', active ? '0' : '-1');
        panel.inert = !active;
      });

      if (focusTab && this.tabs[nextIndex]) this.tabs[nextIndex].focus();
      this.updateIndicator();

      if (animate && !this.reducedMotion.matches) {
        this.animateViewportHeight(startHeight);
      } else {
        this.syncViewportHeight(false);
      }
    }

    animateViewportHeight(startHeight) {
      var self = this;
      var activePanel = this.panels[this.activeIndex];
      if (!activePanel) return;

      this.viewport.style.height = Math.max(1, startHeight) + 'px';
      global.requestAnimationFrame(function () {
        self.viewport.style.height = Math.max(1, activePanel.scrollHeight) + 'px';
      });
      if (this.heightTimer) global.clearTimeout(this.heightTimer);
      this.heightTimer = global.setTimeout(function () {
        self.viewport.style.height = 'auto';
      }, 380);
    }

    syncViewportHeight(animate) {
      var activePanel = this.panels[this.activeIndex];
      if (!activePanel) return;
      if (!animate || this.reducedMotion.matches) {
        this.viewport.style.height = 'auto';
        return;
      }
      this.animateViewportHeight(this.viewport.getBoundingClientRect().height);
    }

    updateIndicator() {
      var activeTab = this.tabs[this.activeIndex];
      var tablist = activeTab && activeTab.parentElement;
      if (!activeTab || !tablist) return;
      tablist.style.setProperty('--vl-blog-tab-x', activeTab.offsetLeft + 'px');
      tablist.style.setProperty('--vl-blog-tab-width', activeTab.offsetWidth + 'px');
    }

    loadAllProducts() {
      var self = this;
      this.panels.forEach(function (panel) {
        self.loadProduct(panel);
      });
    }

    loadProduct(panel) {
      var self = this;
      var handle = panel.dataset.productHandle;
      if (!handle || panel.dataset.productLoaded === 'true' || panel.dataset.productLoading === 'true') {
        return Promise.resolve();
      }

      panel.dataset.productLoading = 'true';
      panel.setAttribute('aria-busy', 'true');
      return global.fetch(productCardUrl(handle), {
        credentials: 'same-origin',
        signal: this.controllerAbort.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product not found: ' + handle);
          return response.text();
        })
        .then(function (html) {
          panel.innerHTML = html;
          panel.dataset.productLoaded = 'true';
          panel.removeAttribute('data-product-loading');
          panel.setAttribute('aria-busy', 'false');

          var tab = self.tabs[Number(panel.dataset.productIndex)];
          var productTitle = panel.querySelector('.grid-product__title');
          var tabLabel = tab && tab.querySelector('span');
          if (tab && tab.dataset.autoLabel === 'true' && tabLabel && productTitle) {
            var loadedTitle = String(productTitle.textContent || '').trim();
            if (loadedTitle) tabLabel.textContent = loadedTitle;
            global.requestAnimationFrame(self.updateIndicator.bind(self));
          }
          if (panel.classList.contains('is-active')) self.syncViewportHeight(true);
          panel.addEventListener('load', function () {
            if (panel.classList.contains('is-active')) self.syncViewportHeight(true);
          }, { capture: true, once: true, signal: self.controllerAbort.signal });
          self.dispatchEvent(new CustomEvent('vl:blog-product-loaded', {
            bubbles: true,
            detail: { handle: handle, panel: panel }
          }));
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          panel.dataset.productError = 'true';
          panel.removeAttribute('data-product-loading');
          panel.setAttribute('aria-busy', 'false');
          panel.innerHTML = '<p class="vl-blog-double-add-module__error">This product could not be loaded. Please refresh and try again.</p>';
          if (panel.classList.contains('is-active')) self.syncViewportHeight(true);
          console.warn('[VL Blog double add module] Failed to load product.', error);
        });
    }
  }

  global.VlBlogDoubleAddModuleTest = {
    clampIndex: clampIndex,
    productCardUrl: productCardUrl,
    parseBoolean: parseBoolean,
    readDataValue: readDataValue,
    parseShortcodeConfig: parseShortcodeConfig,
    hydrateShortcode: hydrateShortcode,
    initShortcodes: initShortcodes
  };

  if (global.customElements && !global.customElements.get(COMPONENT_NAME)) {
    global.customElements.define(COMPONENT_NAME, VlBlogDoubleAddModule);
  }

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', function () {
        initShortcodes(global.document);
      });
    } else {
      initShortcodes(global.document);
    }
    global.document.addEventListener('shopify:section:load', function (event) {
      initShortcodes(event.target);
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
